import Vue from 'vue';
import VueRouter, {Route} from 'vue-router';
import {slash} from 'common/util';
import {loginIntercept} from 'common/user-info';
import MJSSDK from '@mfex/mjssdk';
// import {updateShareConfig} from 'common/share';
import {addImpressionStatic} from 'common/bi-report-v2';
import Conf from 'site-config';
import {updateShareConfig} from 'common/share';
import path from 'path';
import {nextTick} from '@vue/composition-api';

const {TITLE, BI_POSITION} = Conf;

Vue.use(VueRouter);

const notFound = () => import('v-component/page/not-found.vue');

export const ROUTER_NAME = {
    TAOKE_BRAND_AREA: 'taoke-brand-area',
    TAOKE_SUBJECT: 'taoke-subject',
    INDEX: 'index',
    MORE_SHOPPING_LIST: 'more-shopping-list',
    GOODS_DETAIL: 'goods-detail',
    RECOMMEND_LIST: 'recommend-list',
    SHOPPING_LIST: 'shopping-list'
};

// 配置个人中心 title
const userMap = {
    'user-center': '个人中心',
    'user-browse-history': '浏览历史',
    'user-favorites': '我的收藏',
    'user-goodsfeedback-history': '纠错记录',
    'user-business': '商家合作',
    'user-contract': '联系小编'
};

// 页面 title 默认 “非买不可”，不使用默认值需要在此处配置
const otherMap = {
    search: '找券助手', // 搜索
    'search-result': '找券助手',
    seckill: '限时抢购',
    video: '短视频',
    [ROUTER_NAME.MORE_SHOPPING_LIST]: '购物清单',
    'shopping-recommend-list': '购物清单', // 2020 购物清单
    // index: '非买不可',
    'shopping-collect-index': '待购列表',
    'shopping-good-list': '物品列表',
    [ROUTER_NAME.TAOKE_SUBJECT]: ' ',
    [ROUTER_NAME.TAOKE_BRAND_AREA]: '品牌专区'
};
const dynamicRoutesMap = {
    [ROUTER_NAME.RECOMMEND_LIST]: '清单列表',
    [ROUTER_NAME.GOODS_DETAIL]: '商品详情',
    'shopping-list': '购物清单',
    subject: '专题活动'
    // 'new-recommend-list':'购物清单', // 2017 新清单 线上已关闭入口，不维护
};

const keepAliveRoutes = [ROUTER_NAME.INDEX, ROUTER_NAME.TAOKE_SUBJECT, ROUTER_NAME.MORE_SHOPPING_LIST];

export const allPages = {...dynamicRoutesMap, ...otherMap, ...userMap};

const othersPages = require['context']('v-component/page/', false, /\/.+?\.vue$/, 'lazy')
    .keys()
    .map(slash)
    .filter(pagePath => {
        return !(pagePath.match(/\/user-(.+?).vue$/) || pagePath.match(/\/(app|not-found).vue/));
    });

const userPages = require['context']('v-component/page/', false, /user-(.+?)\.vue$/, 'lazy')
    .keys()
    .map(slash);

const userPagesName = userPages.map(pagePath => ({name: pagePath.replace(/.\/(.+?).vue$/, '$1'), path: pagePath}));

const othersPagesName: Array<{name: string; pagePath: string}> = [];
othersPages.forEach(pagePath => {
    const name = pagePath.replace(/.\/(.+?).vue$/, '$1');
    if (!dynamicRoutesMap[name] && !userMap[name]) {
        othersPagesName.push({name, pagePath});
    }
});

// 个人中心相关路由
const userRoutes = userPagesName.map(({name}) => {
    return {
        path: `/${name}`,
        name,
        component: () => import(`v-component/page/${name}.vue`), // 这里有个坑，webpack 编译es6 动态引入 import(path) 时不能传入变量，但一定要用变量的时候，可以通过字符串模板来提供部分信息给webpack；如 `xxx${aa}`
        meta: {
            title: userMap[name] || TITLE,
            requiresAuth: true, // 配置此条，进入页面前判断是否需要登陆
            position: name
        }
    };
});

const othersRoutes = othersPagesName.map(({name}) => {
    return {
        path: `/${name}`,
        name,
        component: () => import(`v-component/page/${name}.vue`), // 这里有个坑，webpack 编译es6 动态引入 import(path) 时不能传入变量，但一定要用变量的时候，可以通过字符串模板来提供部分信息给webpack；如 `xxx${aa}`
        meta: {
            title: otherMap[name] || TITLE,
            position: name,
            keepAlive: keepAliveRoutes.includes(name)
        }
    };
});

// 动态路由 /user/:username/post/:post_id
const dynamicRoutes = [
    {
        name: 'subject',
        path: '/subject/:subject_id',
        component: () => import('v-component/page/subject.vue'),
        meta: {
            title: dynamicRoutesMap['subject'] || TITLE,
            position: 'subject'
        }
    },
    {
        name: ROUTER_NAME.GOODS_DETAIL,
        path: '/goods-detail/:goods_id',
        component: () => import('v-component/page/goods-detail.vue'),
        meta: {
            title: dynamicRoutesMap[ROUTER_NAME.GOODS_DETAIL] || TITLE,
            position: ROUTER_NAME.GOODS_DETAIL
        }
    },
    {
        name: ROUTER_NAME.RECOMMEND_LIST,
        path: '/recommend-list/:list_id',
        component: () => import('v-component/page/recommend-list.vue'),
        meta: {
            title: otherMap[ROUTER_NAME.RECOMMEND_LIST] || TITLE,
            position: ROUTER_NAME.RECOMMEND_LIST
        }
    },
    {
        name: ROUTER_NAME.SHOPPING_LIST,
        path: '/shopping-list/:id',
        component: () => import('v-component/page/shopping-list.vue'),
        meta: {
            title: dynamicRoutesMap[ROUTER_NAME.SHOPPING_LIST] || TITLE,
            position: ROUTER_NAME.SHOPPING_LIST
        }
    }
];

const routes = [
    ...userRoutes,
    ...othersRoutes,
    ...dynamicRoutes,
    {
        path: '/',
        redirect: 'index'
    },
    {
        path: '*',
        component: notFound,
        meta: {
            title: TITLE,
            keepAlive: true
        }
    }
    // 404
];

export const resumeScrollTop = scrollToTop => {
    nextTick(() => {
        document.getElementsByClassName('content')[0].scrollTop = scrollToTop;
    });
};

const scrollBehavior = (to, from) => {
    if (to.name !== from.name && to.meta.keepAlive && to.meta.scrollToTop !== 0) {
        resumeScrollTop(to.meta.scrollToTop);
    }
};

const ROUTER_BASE = '/m';

const router = new VueRouter({
    routes: routes,
    base: ROUTER_BASE,
    mode: 'history', // 考虑后期采用 node-ssr, 不采用 hash 模式
    scrollBehavior
});

const customShareConfigRoute = ['index', ROUTER_NAME.TAOKE_SUBJECT, ROUTER_NAME.GOODS_DETAIL];

// 是否是第一次加载
let isFirstLoad = true;

router.beforeEach(async (to, from, next) => {
    if (to.query.code) {
        // 缓存已登录的 app code 用于 app 联登
        localStorage.setItem('appCode', to.query.code as string);
    }
    const fullPath = to.fullPath;

    if (from.name === 'user-business') {
        location.href = fullPath ? `${location.origin}/m${fullPath}` : location.href;
    } else if (to.matched.some(record => record.meta.requiresAuth)) {
        // 验证是否需要登陆
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (await loginIntercept(fullPath)) {
            next();
        }
    } else {
        next(); // 确保一定要调用 next()
    }
});

export function recordScrollTop(to, from) {
    if (from.meta.keepAlive) {
        from.meta.scrollToTop = document.getElementsByClassName('content')[0]?.scrollTop || 0;
    }
}

export function getCurrentRouteAbsolutePath(route: Route) {
    const link = path.join(`${window.location.hostname}`, ROUTER_BASE, route.fullPath);
    return `${window.location.protocol}//${link}`;
}

router.afterEach((to, from) => {
    recordScrollTop(to, from);

    if (MJSSDK.UA.mamaApp) {
        MJSSDK.setCloseButton({isShow: false}); // 隐藏关闭按钮
        MJSSDK.disabledPullRefresh(); // 禁止下拉刷新
    }

    addImpressionStatic(BI_POSITION.MAI_PAGE);

    if (!customShareConfigRoute.some(name => to.name === name)) {
        updateShareConfig({
            title: to.meta.title,
            link: getCurrentRouteAbsolutePath(to)
        });
    }

    // 百度统计
    // 添加百度统计
    if (!isFirstLoad) {
        window._hmt = window._hmt || [];
        window._hmt.push(['_trackPageview', location.href]);

        // 标记第一次访问的路由
        (to.meta || (to.meta = {})).isFisrtRoute = true;
    } else {
        isFirstLoad = false;
    }
});

export default router;
